
    import React from 'react';
    import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "icon-more-horizontal-24_OAxTa",
  "use": "icon-more-horizontal-24_OAxTa-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-more-horizontal-24_OAxTa\">\n<g transform=\"translate(4 10)\">\n<path d=\"M14 0C15.1 0 16 0.9 16 2C16 3.1 15.1 4 14 4C12.9 4 12 3.1 12 2C12 0.9 12.9 0 14 0ZM8 4C6.9 4 6 3.1 6 2C6 0.9 6.9 0 8 0C9.1 0 10 0.9 10 2C10 3.1 9.1 4 8 4ZM2 4C0.9 4 0 3.1 0 2C0 0.9 0.9 0 2 0C3.1 0 4 0.9 4 2C4 3.1 3.1 4 2 4Z\" />\n</g>\n</symbol>"
});
    sprite.add(symbol);

    const IconMoreHorizontal_24OAxTaSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "icon-more-horizontal-24_OAxTa", width: 24, height: 24, ...props })
    }

    export { IconMoreHorizontal_24OAxTaSpriteSymbolComponent as ReactComponent };
  